"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideFilterItemGroup = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const ArrowIcon_1 = require("../ArrowIcon");
const LinkButton_1 = require("../controls/LinkButton");
const FormGroupContext_1 = require("../FormGroupContext");
const helpers_1 = require("../helpers");
const layouts_1 = require("../layouts");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const View_1 = require("../View");
const ClearIcon_1 = require("./icons/ClearIcon");
const DEFAULT_TEXTS = {
    clear: 'Clear'
};
const arrowIconColor = ({ hasFilters }) => !hasFilters &&
    (0, styled_components_1.css) `
        fill: ${({ theme }) => theme.colorTextMain};
    `;
const StyledArrowDownIcon = (0, styled_components_1.default)(ArrowIcon_1.ArrowDownIcon) `
    ${arrowIconColor};
`;
const StyledArrowRightIcon = (0, styled_components_1.default)(ArrowIcon_1.ArrowRightIcon) `
    ${arrowIconColor};
`;
const WrapperIconCSS = (0, styled_components_1.css) `
    display: flex;
    width: ${helpers_1.SIZE_M};
    height: ${helpers_1.SIZE_M};
`;
const WrapperArrow = styled_components_1.default.div `
    min-width: ${helpers_1.SIZE_M};
    ${WrapperIconCSS}
`;
const Title = (0, styled_components_1.default)(Text_1.Text) `
    padding-left: ${helpers_1.SIZE_XXS};
    line-height: ${helpers_1.FONT_LINE_HEIGHT_L};
    cursor: default;
`;
const WrapperClearIcon = styled_components_1.default.div `
    margin-right: ${helpers_1.SPACING_S};
    ${WrapperIconCSS}
`;
const Wrapper = (0, styled_components_1.default)(StackView_1.StackView) `
    padding: 0 ${helpers_1.SPACING_M};
    position: relative;

    ${({ hasBorder, theme }) => hasBorder &&
    (0, styled_components_1.css) `
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                border-left: ${helpers_1.SIZE_XS} solid ${theme.colorStripeAccent};
            }
        `}
`;
const SideFilterItemGroup = (_a) => {
    var { title, hasFilters = false, disabled = false, opened: externalOpened = true, contentRenderer, texts, onClearClick } = _a, rest = __rest(_a, ["title", "hasFilters", "disabled", "opened", "contentRenderer", "texts", "onClearClick"]);
    const [opened, setOpened] = (0, react_1.useState)(externalOpened);
    (0, react_1.useEffect)(() => {
        if (externalOpened) {
            setOpened(externalOpened);
        }
    }, [externalOpened]);
    const uiTexts = Object.assign(Object.assign({}, DEFAULT_TEXTS), texts);
    const handleClickTitle = () => {
        setOpened(!opened);
    };
    return (react_1.default.createElement(Wrapper, { spaceFill: View_1.SPACE_FILL.all, direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s, hasBorder: hasFilters, "data-selector-id": rest['data-selector-id'] },
        react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.center, direction: StackView_1.STACK_DIRECTION.row, distribution: StackView_1.STACK_DISTRIBUTION.between },
            react_1.default.createElement(WrapperArrow, { onClick: handleClickTitle }, opened ? (react_1.default.createElement(StyledArrowDownIcon, { hasFilters: hasFilters })) : (react_1.default.createElement(StyledArrowRightIcon, { hasFilters: hasFilters }))),
            react_1.default.createElement(Title, { weight: Text_1.TEXT_WEIGHT.bold, view: hasFilters ? Text_1.TEXT_VIEW.link : Text_1.TEXT_VIEW.primary, truncate: true, onClick: handleClickTitle, "data-selector-id": rest['data-selector-id'] ? `title-${rest['data-selector-id']}` : undefined }, title),
            react_1.default.createElement(layouts_1.Spacer, null),
            hasFilters && (react_1.default.createElement(LinkButton_1.LinkButton, { onClick: onClearClick, disabled: disabled, compact: true },
                react_1.default.createElement(StackView_1.StackView, { indentLeft: View_1.INDENT.m, align: StackView_1.STACK_ALIGN.center },
                    react_1.default.createElement(WrapperClearIcon, null,
                        react_1.default.createElement(ClearIcon_1.ClearIcon, { isDisabled: disabled })),
                    uiTexts.clear)))),
        opened && (react_1.default.createElement(FormGroupContext_1.FormGroupContextProvider, { value: { disabled } }, contentRenderer({ disabled })))));
};
exports.SideFilterItemGroup = SideFilterItemGroup;
//# sourceMappingURL=SideFilterItemGroup.js.map